import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";

const useDeleteRosterPlayer = () => {
  const { sport, organizationId, seasonId, fixtureId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (personId: string) => {
      const url = fixtureId
        ? `${sport}/o/${organizationId}/fixtures/${fixtureId}/persons/${personId}/roster`
        : `${sport}/o/${organizationId}/seasons/${seasonId}/persons/${personId}/roster`;
      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        const queryKeyId = fixtureId ? "fixtureRoster" : "seasonRoster";
        await queryClient.invalidateQueries({
          queryKey: [queryKeyId, sport, organizationId, seasonId],
        });
        if (!fixtureId) {
          await queryClient.invalidateQueries({
            queryKey: ["seasonRosterShort", sport, organizationId, seasonId],
          });
        }
      }
    },
  });
};

export default useDeleteRosterPlayer;
